import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { MenuElementDto } from '@rsmu/oep-api';

@Injectable({
  providedIn: 'root'
})
export class MenuService {

  constructor() { }

  private menuItemsSubject = new BehaviorSubject<MenuElementDto[]>([]);
  menuItems$ = this.menuItemsSubject.asObservable();

  private parentLinkSubject = new BehaviorSubject('');
  parentLink$ = this.parentLinkSubject.asObservable();

  setMenuItems(items: MenuElementDto[]) {
    this.menuItemsSubject.next(items);
  }

  setParentLink(link: string) {
    this.parentLinkSubject.next(link);
  }
}
